import { defaultTheme } from "react-admin";

const customTheme = {
  ...defaultTheme,
  ...{
    palette: {
      secondary: {
        main: "#fff",
      },
    },
    MuiTableRow: {
      root: {
        height: 40,
      },
    },
    // components: {
    //   ...defaultTheme.components,
    //   RaDatagridRow: {
    //     styleOverrides: {
    //       root: {
    //         color: red,
    //       },
    //     },
    //   },
    // },
  },
};

export default customTheme;
